// Runtime settings come from window.__ENV__ (written by env-config.js when the container starts).
// Build-time REACT_APP_* values and the previous defaults remain as fallbacks.
const runtime = window.__ENV__ || {};

export const API_URL =
    runtime.REACT_APP_API_URL ||
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'development' ? 'http://localhost:5001/api/v1' : 'https://dashboard.vas.kashier.io/api/v1');

export const PAYMENT_URL = runtime.REACT_APP_PAYMENT_URL || process.env.REACT_APP_PAYMENT_URL || 'https://kashier-usd.herokuapp.com';

export const APP_VERSION = runtime.REACT_APP_VERSION || process.env.REACT_APP_VERSION;
